module.exports = __webpack_public_path__ + "static/media/registp04_en.33a2058e.png";